var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "address-cascader" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            title: "选择省市区",
            width: "560px",
            "close-on-click-modal": false,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            opened: _vm.onDialogOpened,
          },
        },
        [
          _c("div", { staticClass: "address-dialog-body" }, [
            _c("div", { staticClass: "popover-label" }, [_vm._v("输入地址")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "autocomplete-wrapper" },
              [
                _c("el-input", {
                  ref: "addressInput",
                  attrs: {
                    placeholder:
                      "请输入省市区及详细地址，如：北京市朝阳区望京SOHO",
                    size: "small",
                  },
                  on: { input: _vm.handleDetailInput },
                  nativeOn: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.handleEnterKey($event)
                    },
                  },
                  model: {
                    value: _vm.detailText,
                    callback: function ($$v) {
                      _vm.detailText = $$v
                    },
                    expression: "detailText",
                  },
                }),
                _vm._v(" "),
                _vm.autocompleteVisible && _vm.autocompleteResults.length > 0
                  ? _c(
                      "div",
                      { staticClass: "autocomplete-dropdown" },
                      _vm._l(_vm.autocompleteResults, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "autocomplete-item",
                            class: {
                              "is-active": _vm.autocompleteIndex === index,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.selectAutocompleteItem(item)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-location",
                              staticStyle: {
                                color: "#409EFF",
                                "margin-right": "6px",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item.name))]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "autocomplete-district" },
                              [_vm._v(_vm._s(item.district))]
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "popover-label",
                staticStyle: { "margin-top": "12px" },
              },
              [_vm._v("地图定位")]
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "address-map",
              attrs: { id: "addressCascaderMap" },
            }),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-input",
        {
          attrs: {
            value: _vm.displayText,
            placeholder: "请点击输入省市区及详细地址",
            readonly: "",
          },
          on: {
            focus: function ($event) {
              _vm.visible = true
            },
          },
        },
        [
          _c("i", {
            staticClass: "el-icon-location el-input__icon",
            staticStyle: { cursor: "pointer" },
            attrs: { slot: "suffix" },
            on: {
              click: function ($event) {
                _vm.visible = true
              },
            },
            slot: "suffix",
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }